import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

function ConfirmWindow({ header, message, onShowAction, onYesAction, onNoAction }) {

    const [headerMessage, setHeaderMessage] = useState((header == null) ? "Confirm" : header);
    const [bodyMessage, setBodyMessage] = useState((message == null) ? "Confirm Action. Do you wish to proceed?" : message);
    const [modal, setModal] = useState(true);

    const onOk = (event) => {
        onShowAction(true);
        onYesAction(event);
    };

    const onCancel = (event) => {
        onShowAction(true);
        onNoAction( event);
    };

    return (
        <div>
            <Modal isOpen={modal}>
                <ModalHeader>{headerMessage}</ModalHeader>
                <ModalBody>
                    {bodyMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={onCancel}>
                        Cancel{' '}
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </Button>
                    {' '}
                    <Button color="primary" onClick={onOk}>
                        Ok{' '}
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default ConfirmWindow;